import * as React from "react"
import type { SVGProps } from "react"
const SvgQuote = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M17.45 7.64 16 10.14q1.65 0 2.83 1.18Q20 12.49 20 14.14c0 1.65-.4 2.04-1.17 2.83q-1.18 1.17-2.83 1.17c-1.65 0-2.04-.39-2.82-1.17A4 4 0 0 1 12 14.14q0-.57.14-1.06a4 4 0 0 1 .41-.94l3.18-5.5a1 1 0 0 1 .85-.5q.57 0 .86.5a1 1 0 0 1 .01 1m-9 0L7 10.14q1.65 0 2.83 1.18Q11 12.49 11 14.14c0 1.65-.4 2.04-1.17 2.83Q8.65 18.14 7 18.14c-1.65 0-2.04-.39-2.82-1.17A4 4 0 0 1 3 14.14a4 4 0 0 1 .55-2l3.18-5.5a1 1 0 0 1 .84-.5q.58 0 .87.5a1 1 0 0 1 .01 1m7.55 5q-.63 0-1.06.44a1.5 1.5 0 0 0-.44 1.06q0 .63.44 1.07.43.43 1.06.43t1.06-.43q.45-.45.44-1.07 0-.62-.44-1.06a1.5 1.5 0 0 0-1.06-.44m-9 0q-.63 0-1.06.44a1.5 1.5 0 0 0-.44 1.06q0 .63.44 1.07.43.43 1.06.43t1.06-.43q.45-.45.44-1.07 0-.62-.44-1.06A1.5 1.5 0 0 0 7 12.64" />
  </svg>
)
export default SvgQuote
